export default "__VITE_ASSET__DVoZ4Azg__"